import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';

@Directive({
  selector: '[appMultiselectTabFix]',
})
export class DropdownFocusDirective {
  @Input() nextFocusSelector = ''; // CSS selector for the next element to focus

  constructor(private el: ElementRef, private host: MultiSelect) {}

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab' && this.host.overlayVisible) {
      event.preventDefault();
      this.host.hide();

      // If nextFocusSelector specified, focus that element.
      if (this.nextFocusSelector) {
        const nextEl = document.querySelector<HTMLElement>(this.nextFocusSelector);
        if (nextEl) {
          setTimeout(() => nextEl.focus(), 0);
          return;
        }
      }

      // fallback: find next focusable element after this multiselect
      setTimeout(() => {
        const next = this.findNextFocusable(this.el.nativeElement);
        next?.focus();
      }, 0);
    }
  }

  private findNextFocusable(el: HTMLElement): HTMLElement | null {
    const focusable = Array.from(
      document.querySelectorAll<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      (elem) => !elem.hasAttribute('disabled') && elem.offsetParent !== null && elem.tabIndex >= 0
    );

    const currentIndex = focusable.indexOf(el);
    return currentIndex > -1 && currentIndex < focusable.length - 1 ? focusable[currentIndex + 1] : null;
  }
}
